import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/ui/mentionsview
 */
import ListView from '@ckeditor/ckeditor5-ui/src/list/listview';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import '../../theme/mentionui.css';
/**
 * The mention ui view.
 *
 * @extends module:ui/list/listview~ListView
 */

var MentionsView =
/*#__PURE__*/
function (_ListView) {
  _inherits(MentionsView, _ListView);

  /**
   * @inheritDoc
   */
  function MentionsView(locale) {
    var _this;

    _classCallCheck(this, MentionsView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MentionsView).call(this, locale));

    _this.extendTemplate({
      attributes: {
        class: ['ck-mentions'],
        tabindex: '-1'
      }
    });

    return _this;
  }
  /**
   * {@link #select Selects} the first item.
   */


  _createClass(MentionsView, [{
    key: "selectFirst",
    value: function selectFirst() {
      this.select(0);
    }
    /**
     * Selects next item to the currently {@link #select selected}.
     *
     * If the last item is already selected, it will select the first item.
     */

  }, {
    key: "selectNext",
    value: function selectNext() {
      var item = this.selected;
      var index = this.items.getIndex(item);
      this.select(index + 1);
    }
    /**
     * Selects previous item to the currently {@link #select selected}.
     *
     * If the first item is already selected, it will select the last item.
     */

  }, {
    key: "selectPrevious",
    value: function selectPrevious() {
      var item = this.selected;
      var index = this.items.getIndex(item);
      this.select(index - 1);
    }
    /**
     * Marks item at a given index as selected.
     *
     * Handles selection cycling when passed index is out of bounds:
     * - if the index is lower than 0, it will select the last item,
     * - if the index is higher than the last item index, it will select the first item.
     *
     * @param {Number} index Index of an item to be marked as selected.
     */

  }, {
    key: "select",
    value: function select(index) {
      var indexToGet = 0;

      if (index > 0 && index < this.items.length) {
        indexToGet = index;
      } else if (index < 0) {
        indexToGet = this.items.length - 1;
      }

      var item = this.items.get(indexToGet); // Return early if item is already selected.

      if (this.selected === item) {
        return;
      } // Remove highlight of previously selected item.


      if (this.selected) {
        this.selected.removeHighlight();
      }

      item.highlight();
      this.selected = item; // Scroll the mentions view to the selected element.

      if (!this._isItemVisibleInScrolledArea(item)) {
        this.element.scrollTop = item.element.offsetTop;
      }
    }
    /**
     * Triggers the `execute` event on the {@link #select selected} item.
     */

  }, {
    key: "executeSelected",
    value: function executeSelected() {
      this.selected.fire('execute');
    } // Checks if an item is visible in the scrollable area.
    //
    // The item is considered visible when:
    // - its top boundary is inside the scrollable rect
    // - its bottom boundary is inside the scrollable rect (the whole item must be visible)

  }, {
    key: "_isItemVisibleInScrolledArea",
    value: function _isItemVisibleInScrolledArea(item) {
      return new Rect(this.element).contains(new Rect(item.element));
    }
  }]);

  return MentionsView;
}(ListView);

export { MentionsView as default };